
(function(template){
    define('vue!app/views/vue/e-reg-vue-app/reusableComponents/signature',['Vue', 'signaturePad'],function(Vue, signaturePad){
        return {
            name:'signature',
            template:template,
            props: ['signature'],
            data: function(){
                return {
                    signaturePad: null
                }
            },
            methods: {
                clearSignature: function() { // use refs to access this method from parent.
                    if(!this.signaturePad) return;
                    this.signaturePad.clearCanvas();
                    this.$emit('update', null);
                },
                handleSignatureUpdate: function() {
                    if(!this.signaturePad) return;
                    var data = btoa(JSON.stringify(this.signaturePad.getSignature()))
                    this.$emit('update', data); // "data" contains an encrypted string containing the signature array.
                }
            },
            mounted: function() {
                this.signaturePad = $('.sigPad').signaturePad({
	                                  drawOnly:true,
	                                  lineColour: '#DDD',
	                                  lineTop: 300,
	                                  lineMargin: 10
                                    });

                if((this.signature || '').length > 0) {
                    var data = JSON.parse(atob(this.signature));
                    this.signaturePad.regenerate(data);
                }
                                    
            }
        }
    })
})('<div class="control sigPad"> <div class="sig sigWrapper"> <canvas class="pad" @touchend="handleSignatureUpdate" @mouseup="handleSignatureUpdate"></canvas> </div> </div>');
